import React from "react";
import classes from './Logo.module.css';

const Logo = (props) => {
    return <div id="logo">
        <h1 className={classes.name}>yuenkev</h1>
    </div>
}

export default Logo;